<template>
  <div class="settings-view is-narrow">
    <PageHeader title="Preferences" subtitle="Choose how the knowledge base looks for you." />
    <SettingsSection title="Theme" description="Auto follows your operating system setting.">
      <div class="theme-options">
        <button
          v-for="option in options"
          :key="option.mode"
          type="button"
          class="theme-option"
          :class="{ active: currentThemeMode === option.mode }"
          :aria-pressed="currentThemeMode === option.mode"
          @click="select(option.mode)"
        >
          <component :is="option.icon" class="icon" />
          <span>{{ option.label }}</span>
          <Check v-if="currentThemeMode === option.mode" class="icon theme-option-check" />
        </button>
      </div>
    </SettingsSection>
  </div>
</template>

<script setup lang="ts">
import { Check, Monitor, Moon, Sun } from 'lucide-vue-next';
import type { Component } from 'vue';
import PageHeader from '../components/settings/PageHeader.vue';
import SettingsSection from '../components/settings/SettingsSection.vue';
import { currentThemeMode, setThemeMode, ThemeMode, type ThemeMode as ThemeModeValue } from '../theme';

interface ThemeOption {
  mode: ThemeModeValue;
  label: string;
  icon: Component;
}

const options: ThemeOption[] = [
  { mode: ThemeMode.AUTO, label: 'Match system', icon: Monitor },
  { mode: ThemeMode.LIGHT, label: 'Light', icon: Sun },
  { mode: ThemeMode.DARK, label: 'Dark', icon: Moon }
];

function select(mode: ThemeModeValue): void {
  setThemeMode(mode);
}
</script>
